"use strict";
/**
 * @description 关系图的边
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("./base");
var edge_1 = require("./shape/edge");
var Edge = /** @class */ (function (_super) {
    tslib_1.__extends(Edge, _super);
    function Edge(cfg) {
        var _this = _super.call(this, tslib_1.__assign({ type: 'edge', generatePoints: true, shapeType: 'edge', shareTooltip: false }, cfg)) || this;
        _this.set('shapeFactory', edge_1.default);
        return _this;
    }
    return Edge;
}(base_1.default));
exports.default = Edge;
//# sourceMappingURL=edge.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/edge.js
// module id = 807
// module chunks = 37